import { createContext, useState } from "react";

export const AuthContext = createContext();

const AuthContextProvider = ({ children }) => {
  const [userData, setUserData] = useState({
    user: null,
    isAuthenticated: false,
    usertype: null,
    userRole: null,
  });

  const changeUserData = (user) => {
    setUserData({ ...userData, ...user });
  };

  const value = {
    changeUserData,
    setUserData,
    userData,
  };
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export default AuthContextProvider;
